module.exports = __webpack_public_path__ + "img/add-user.718dd1cc.svg";